import Container from '@building/vuepage/example/index.vue';
import Operation from '@building/vuepage/example/operation-filter.vue'

import ExampleList from '../vuepage/example/list.vue';
import ExampleEditor from '../vuepage/example/editor.vue';
import MultiPleDownload from '../vuepage/example/multiple-download.vue'

export default [
  {
    path: '/example-management',
    component: Container,
    children: [
      {
        path: 'example-list',
        component: ExampleList,
        meta: [
          {
            name: '样例管理',
            url: '/example-management',
          },
          {
            name: '/xx列表',
            url: 'example-list',
          },
        ],
      },
      {
        path: 'example-editor',
        component: ExampleEditor,
        meta: [
          {
            name: '样例管理',
            url: '/example-management',
          },
          {
            name: 'xx列表',
            url: 'example-list',
          },
          {
            name: '富文本编辑',
            url: 'example-editor',
          },
        ],
      },
      {
        path: 'multiple-download',
        component: MultiPleDownload,
        meta: [
          {
            name: '样例管理',
            url: '/example-management',
          },
          {
            name: '批量下载',
            url: 'multiple-download',
          },
        ],
      },
      {
        path: 'operation',
        component: Operation,
        meta: [
          {
            name: '样例管理',
            url: '/example-management',
          },
          {
            name: '操作权限控制',
            url: 'operation',
          },
        ],
      },
    ],
  },
];
